<section class="page-wrapper">
    <app-fund-allocation
        [lenderBasicInfo]="lenderBasicInfo"
        [productsData]="productsData"
        [flexInvestmentAmount]="flexInvestmentAmount"
        [maxInvestmentAmount]="maxInvestmentAmount"
    ></app-fund-allocation>
</section>